import { integration } from '../integration';
import { store } from '../stores/mainStore';

export class HTTPServer {
	constructor(server) {
		this.server = server;
		this.mode = 'production';
		this.failMode = 'first';
		this.qa = {};
	}

	SetDebugMode(mode, failMode) {
		this.mode = mode;
		this.failMode = failMode;
	}

	//TODO: refactor retryCount, which is named poorly since it is used to allow retires to be avoided by setting -1 and setting it to a positive number will not have the expected result
	CallRoute(route, payload, method = 'POST', retryCount = 0) {
		// window.manager.logWrapperMsg("calling ROUTE "+route);
		return new Promise((resolve, reject) => {
			//console.log("6214 CallRoute: "+route, 'tok =', this.token);

			const call = (retryCount) => {
				//Call a structured route
				let request = { method,
					Route: route,
					Payload: payload,
				};
				store.setSpinner(true);

				return this.SendPacket(request)
					.then((response) => {
						console.log('6214 <--- packet RESPONSE', response)
						store.setSpinner(false);
						if (response.ErrorCode && response.ErrorCode !== 0) {
							// store.debug = store.debug + " " + response.ErrorCode;
							if (response.ErrorCode === 300037) {
								console.log('fb account pending delete');
								retryCount = -1;
								//store.forceGetNotifications();
								return resolve(true);
							}
							if (response.ErrorCode === 300011) {
								console.log('repeat tutorial play');
							}
							if (response.ErrorCode === 300019) {
								console.log('let game retry roll');
							}
							if (response.ErrorCode === 300023) {
								console.warn('account already linked to a userId, login will overwrite the user');
							}
							if (response.ErrorCode === 300040) {
								console.warn('account already deleted');
								//store.user.clearUserData('all');
								//window.manager.updateWrapperPrivacySettings(true, true, true, true);
								return reject('deleted account');
							}
							if (response.ErrorCode === 300024 || response.ErrorCode === 300025) {
								console.warn('Game action failed.');
								store.modal = 'opponentResigned';
							}
							if (response.ErrorCode === 300031) {
								console.log('rejected name');
								return resolve(response);
							} else {
								//There is no default handling of this error code.
								//throw the error to show dialog.
								throw response;
							}
						}
						return resolve(response);
					})
					.catch((err) => {
						if(err.ErrorCode === 300043) { // ERROR_LEAGUES_DISABLED 
							return reject(err)
						}
						if (err.ErrorCode === 300044) {	// ERROR_ACTIVE_MATCHES_LIMIT_EXCEEDED
							store.showMaxMatchLimit = true;
							return null;
						} 

						if (retryCount === -1) {
							//Do not retry. It is ok to fail.
							if(route === 'confirm-email')
								return resolve(err)
						} else {
							/* if(window.manager) {
								if(window.manager.playHandButtonPressed)
									window.manager.playHandButtonPressed = false;
								if(window.manager.extraRollButtonPressed)
									window.manager.extraRollButtonPressed = false;
							} */
							if (!retryCount || retryCount < 5) {
								console.warn(`Will Retry (${retryCount + 1})`, err);
								retryCount += 1;
								setTimeout(() => {
									store.setSpinner(false);
									call(retryCount);
								}, 750 * retryCount);
							} else {
								integration.onError(`Server communication failed at route: ${route}`);
								store.errorMessage = `Server communication failed at route: ${route} ${JSON.stringify(err)}`;
								reject(`route "${route}" failed ${retryCount} times. Could not complete server request.`);
							}
						}
					});
			}; // end call

			call(retryCount || 0);
		});
	}

	SendPacket(packet) {
		if (this.mode === 'qa') {
			let route = packet.Route;
			if (!this.qa[route]) {
				this.qa[route] = 0;
			}
			if (this.failMode === 'first') {
				if (this.qa[route] !== 0) {
					this.qa[route] = 0;
				} else {
					++this.qa[route];
					return new Promise(function (resolve, reject) {
						reject({
							errorCode: 1,
							errorMessage: 'Could not complete server request. First Fail',
						});
					});
				}
			}
		}

		const req = {
			method: packet.method,
			headers: {
				'Authorization': 'Bearer b970869b-4f4d-4046-8b7b-bbceb3a30ac3',
				'Content-Type': 'application/json'
			},
		}
		if(this.accessToken)			req.headers['X-Auth-Token'] = 'Bearer ' + this.accessToken;
		if(packet.method === 'POST')	req.body = JSON.stringify(packet.Payload)
		console.log('6214 ---> REQ =', req)
	
		return fetch(this.server + '/client/' + packet.Route, req).then((response) => {
			return response.json().then((data) => {
				if (data && data.accessToken) {
					this.accessToken = data.accessToken;
				}
				return data;
			});
		});
	}
}
